const loadFonts = (path: string) => `
  
  @font-face {
    font-family: 'FontLight';
    src: url('${path}/fonts/NissanBrand-Light.woff2') format('woff2'),
        url('${path}/fonts/NissanBrand-Light.woff') format('woff');
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }

  @font-face {
    font-family: 'FontRegular';
    src: url('${path}/fonts/NissanBrand-Regular.woff2') format('woff2'),
        url('${path}/fonts/NissanBrand-Regular.woff') format('woff');
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
 
  @font-face {
    font-family: 'FontBold';
    src: url('${path}/fonts/NissanBrand-Bold.woff2') format('woff2'),
        url('${path}/fonts/NissanBrand-Bold.woff') format('woff');
     font-weight: bold;
    font-style: normal;
    font-display: swap;
  }
`;

export default loadFonts;
